import Box from "@mui/material/Box";
import React, {useEffect, useState} from "react";
import Container from "react-bootstrap/Container";
import {DEPARTMETNS_URL} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import DepartmentDialog from "./DepartmentDialog";

function Department() {

  useEffect(() => {
    getDepartments();
  }, []);

  const [data, setData] = useState([]);

  const getDepartments = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(DEPARTMETNS_URL).then((response) =>
      setData(response.data.data)
    );
  };

  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <DepartmentDialog
          editDeptId={""}
          selectedDeptId={""}
          deptName={""}
          callDepts={getDepartments}
          isEdit={false}
        />
      </Box>
      <AppTableView
        rows={data}
        cols={[
          {
            field: "name",
            headerName: "Department Name",
            flex: 1,
            renderCell: (params) => (
              <DepartmentDialog
                editDeptId={params?.row?.id}
                selectedDeptId={params?.row?.id}
                deptName={params?.row?.name}
                callDepts={getDepartments}
                isEdit={true}
              />
            ),
          },
          {
            field: "active",
            headerName: "Active",
            flex: 1,
            renderCell: (params) => (params.value ? "Yes" : "No"),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}
export default Department;
